export const Extension = (props) => {
  return (
    <div id="extension" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h3>
            {`Conference proceedings have been published! Please see the Proceedings section.`.toUpperCase()}
          </h3>
        </div>
      </div>
    </div>
  );
};
